module.exports = __webpack_public_path__ + "static/media/9.ac505b1a.jpg";